import { isPast } from 'date-fns';
import { ServiceReminder } from 'shared/types/graphql';

type RecentActiveServiceReminder = Pick<ServiceReminder, 'dueDate'> & {
  service: ServiceReminder['service']['reminderActivationDate'];
};

export function getRecentActiveServiceReminders<T extends RecentActiveServiceReminder>(serviceReminders: T[]): T[] {
  const isDueDateWithinLimit = (dueDate: string): boolean => {
    const currentYear = new Date().getFullYear();
    const reminderDueDateYear = new Date(dueDate).getFullYear();
    return currentYear - reminderDueDateYear <= 3;
  };

  const isReminderActive = (reminderActivationDate: string): boolean => {
    if (!reminderActivationDate) return false;

    return isPast(new Date(reminderActivationDate));
  };

  return serviceReminders.filter((reminder) => {
    return isReminderActive(reminder.service.reminderActivationDate) && isDueDateWithinLimit(reminder.dueDate);
  });
}
